<template>
    <div id="page-other-count">
        <vx-card ref="filterCard" class="mb-1">
            <vs-row vs-w="12">
                <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12" >
                    <date-range-picker 
                        @date-change="onDateFilterChange" 
                        :initDate="{from: dateFilterFrom, to: dateFilterTo}"
                        actionBtnText="Xem"
                    />
                </vs-col>
                <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12" >
                    <span>Thống kê những máy đánh cược khác banh</span>
                </vs-col>
            </vs-row>
        </vx-card>
        <div class="vx-card pl-5 pr-5">
            <vs-table 
                :data="betCount"
                :max-items="itemsPerPage"
                pagination
                :stripe="true"
                search
            >
                <template slot="header">
                    <div class="flex-grow">
                        <vs-dropdown vs-trigger-click class="cursor-pointer">
                            <div class="p-3 border border-solid d-theme-border-grey-light rounded-full cursor-pointer flex items-center justify-between font-medium">
                                <span class="mr-2">
                                    {{ itemsPerPage }}
                                </span>
                                <feather-icon
                                    icon="ChevronDownIcon"
                                    svgClasses="h-4 w-4"
                                />
                            </div>
                            <vs-dropdown-menu>
                                <vs-dropdown-item :key="ipp" v-for="ipp in [15,25,50,100]" @click="itemsPerPage = ipp"><span>{{ipp}}</span></vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>
                </template>
                <template slot="thead">
                    <vs-th
                        :key="h.id" 
                        v-for="h in header"
                        :sort-key="h.field"
                    >
                        {{ h.title }}
                    </vs-th>
                </template>
                <template slot-scope="{ data }">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :key="h.id" v-for="h in header" :data="data[indextr][h.field]">
                            <template v-if="h.field == 'member_name'">
                                <vs-button 
                                    class="vs-button--link"
                                    color="dark" 
                                    type="flat"
                                    target
                                    :href="{ url: '/bets/other-detail?member_name='+data[indextr].member_name+'&from='+dateFilterFrom+'&to='+dateFilterTo
                                        }"
                                >
                                    {{ data[indextr][h.field].toUpperCase() }}
                                </vs-button>
                            </template>
                            <template v-else>{{ data[indextr][h.field] }}</template>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from "moment";
import DateRangePicker from '@/components/DateRangePicker';

export default {
    data(){
        return {
            itemsPerPage: 25,
            currentPage: 1,
            header: [ 
                { title:"Thành viên", field:"member_name" }, 
                { title:"Số cược", field:"total" },
                { title:"Thắng thua", field:"winloss" }
            ],
            betCount: [],
            dateFilterFrom: moment().subtract(1, "days").format("YYYY-MM-DD"),
            dateFilterTo: moment().subtract(1, "days").format("YYYY-MM-DD"),
        }
    },
    computed:{
        totalPage: function(){
            return Math.ceil(this.betCount.length / this.itemsPerPage);
        }
    },
    beforeRouteUpdate (to, from, next) {
        this.dateFilterFrom = to.query.from;
        this.dateFilterTo = to.query.to;

        this.fetchDuplication();
        next();
    },
    methods:{
        fetchDuplication() {
            let vm = this;
            
            this.$http.get("/bets/other-count?from="+this.dateFilterFrom+"&to="+this.dateFilterTo).then((res) => {
                vm.betCount = res.data.data;
            });
        },
        onDateFilterChange(data){
            this.dateFilterFrom = data.fromDate;
            this.dateFilterTo = data.toDate;

            this.$router.replace({ path: "/bets/other-count?from="+this.dateFilterFrom+"&to="+this.dateFilterTo});
        },
        // onDateRangeAction(){
        //     if(this.ip == "" && this.members == "" && this.match == "" && this.choice == "" && this.handicap == ""){
        //         Swal.fire("", "Vui lòng nhập thông tin để tìm kiếm!", "error");
        //         return;
        //     }

        //     this.fetchQuery();
        // },
        // thisWeek(){
        //     this.$router.push({ path: "/duplication?date=this_week" });
        // }
    },
    components: {
        DateRangePicker
    },
    created(){

        let yesterday =  moment().subtract(1, "days").format("YYYY-MM-DD");

        if(this.$route.query.from && this.$route.query.from == yesterday && 
            this.$route.query.to && this.$route.query.to == yesterday){

            this.dateFilterFrom = yesterday;
            this.dateFilterTo = yesterday;

            this.fetchDuplication();
            return;
        }

        this.$router.replace({ path: "/bets/other-count?from="+yesterday+"&to="+yesterday});
    }
};
</script>

<style>
.swal2-container{
    z-index: 99999;
}
</style>
